<script>
import {
    layoutMethods
} from "@/state/helpers";
import simplebar from "simplebar-vue";
import { eventBus } from '../main.js';

import UserApi from "@/services/users-api";
import ChatApi from "@/services/chat-api";

/**
 * Right sidebar component
 */
export default {
    components: {
        simplebar,
    },
    created() {
        eventBus.$on('notif_chat_new', this.notifChatNewlistener)
    },
    beforeDestroy () {
        eventBus.$off('notif_chat_new', this.notifChatNewlistener)
    },
    mounted() {

        if (sessionStorage.getItem("userFullName") != null) {
        this.connectedUserFullName = sessionStorage.getItem("userFullName");
        }

        this.getCurrentUserId()

        this.getChatUsers()
        this.getRecentUsers()

  },
    data() {
        return {
            config: {
                handler: this.handleRightBarClick,
                middleware: this.middleware,
                events: ["click"],
            },
            layout: this.$store ? this.$store.state.layout.layoutType : {} || {},
            width: this.$store ? this.$store.state.layout.layoutWidth : {} || {},
            topbar: this.$store ? this.$store.state.layout.topbar : {} || {},
            sidebarType: this.$store ?
                this.$store.state.layout.leftSidebarType :
                {} || {},
            loader: this.$store ? this.$store.state.layout.loader : {} || {},

      connectedUserFullName: null,
      username:null,
      usersList:[],
      pagemodelMain: {currentPage : 1, perPage : 50, totalRows: 0},
      isGettingChatContactStarting:false,
      filter:null,
      messagesPagemodelMain:{currentPage : 1, perPage : 5, totalRows: 0},
      chatMessagesData:[],
      isLoadMoreMessagesClicked:false,
      isGettingMessagesStarted:false,
      isLoadMoreClicked:false,
      message:null,
      selectedUser:null,
      currentUserId:null,
      recentUsers:[],
      chatMsgCount: 0,
        };
    },
    methods: {
        ...layoutMethods,
        hide() {
            this.$parent.toggleRightSidebar();
        },
        // eslint-disable-next-line no-unused-vars
        handleRightBarClick(e, el) {
            this.$parent.hideRightSidebar();
        },
        // eslint-disable-next-line no-unused-vars
        middleware(event, el) {
            if(event.target.classList)
            return !event.target.classList.contains("toggle-right");
        },
        changeLayout(layout) {
            this.changeLayoutType({
                layoutType: layout,
            });
        },
        changeType(type) {
            return this.changeLeftSidebarType({
                leftSidebarType: type,
            });
        },
        changeWidth(width) {
            return this.changeLayoutWidth({
                layoutWidth: width,
            });
        },
        changeTopbartype(value) {
            return this.changeTopbar({
                topbar: value,
            });
        },
        changeloader() {
            return this.changeLoaderValue({
                loader: this.loader,
            });
        },

    getCurrentUserId() {
        UserApi.getCurrentUserId().then(
          (result)=>{
              this.currentUserId=result
          }
      )
    },

    notifChatNewlistener() {
        this.getRecentUsers()
        this.reset()
        this.getMessages();
    },

    getMessages(){
        if(this.selectedUser==null || this.selectedUser.id==null){
            return ;
        }
        this.isGettingMessagesStarted=true
        ChatApi.getMessages(this.messagesPagemodelMain.currentPage, this.messagesPagemodelMain.perPage,this.selectedUser.id).then(
          (result)=>{
              if(result){
                  if(this.isLoadMoreMessagesClicked){
                        this.chatMessagesData = result.list.concat(this.chatMessagesData)
                  }else{
                        this.chatMessagesData=result.list    
                  }

                    this.messagesPagemodelMain.totalRows = result.total;
                    this.messagesPagemodelMain.currentPage = result.page;
                    this.messagesPagemodelMain.perPage = result.pageSize;
                    this.messagesPagemodelMain.pageSize = result.pageSize;
                    if(!this.isLoadMoreMessagesClicked){
                        this.handleScroll();
                    }
                    this.isLoadMoreMessagesClicked=false
                    this.isGettingChatContactStarting=false

              }
          }
      ).finally(
          ()=>{
            this.isLoadMoreMessagesClicked=false
            this.isGettingChatContactStarting=false
          }
      )
    },
   chatUsername(data) {
        this.selectedUser=data
        this.username = data.name;
        this.clear();
        this.getMessages()
        this.changeStatus()

    },

    chatRecentUsername(data) {
        this.chatUsername(data)
        this.recentUsers= this.recentUsers.filter(function(ele){ 
            return ele != data; 
        });

    },

    getChatUsers(){
        this.isGettingChatContactStarting=true
        UserApi.getChatUsers(this.pagemodelMain.currentPage, this.pagemodelMain.perPage,this.filter).then(
            (result)=>{
                if(result){
                    if(this.isLoadMoreClicked){
                        // for(var i in result.list ){
                        //     this.usersList.push(result.list[i])
                        // }
                        this.usersList = this.usersList.concat(result.list)
                        this.pagemodelMain.totalRows = result.total;
                        this.pagemodelMain.currentPage = result.page;
                        this.pagemodelMain.perPage = result.pageSize;
                        this.pagemodelMain.pageSize = result.pageSize;
                        this.isLoadMoreClicked=false
                        this.isGettingChatContactStarting=false
                    }else{
                        this.usersList=result.list
                        this.pagemodelMain.totalRows = result.total;
                        this.pagemodelMain.currentPage = result.page;
                        this.pagemodelMain.perPage = result.pageSize;
                        this.pagemodelMain.pageSize = result.pageSize;
                        this.isLoadMoreClicked=false
                        this.isGettingChatContactStarting=false
                    }
                }
                
            }
        ).finally(
          ()=>{
            this.isLoadMoreClicked=false
            this.isGettingChatContactStarting=false
          }
      )
    },
    loadMore(){
        this.pagemodelMain.currentPage +=1 ;
        this.isLoadMoreClicked=true
        this.getChatUsers()

    },

    send(){

        if (!this.message) {
            return;
        }

        let msg = this.message
        ChatApi.sendMessage(msg,this.selectedUser==null ? null : this.selectedUser.id).then(
            (result)=>{
                if(result){
                    this.clear()
                    this.getMessages()
                }
            }
        )
    },

    loadMoreMessages(){
        this.messagesPagemodelMain.currentPage +=1 ;
        this.isLoadMoreMessagesClicked=true
        this.getMessages()
    },

    clear() {
        this.reset()
        this.message=null;
    },

    reset(){
        this.chatMessagesData=[];
        this.messagesPagemodelMain={ currentPage: 1, perPage: 5, totalRows: 0 };
        this.isLoadMoreMessagesClicked=false;
        this.isGettingMessagesStarted=false;
    },

    getRecentUsers(){
        UserApi.getRecentUsers().then(
            (result)=>{
                if(result){
                    this.recentUsers=[]
                    this.recentUsers=result
                }
            }
        )
    },

    handleScroll() {
      if (this.$refs.current.$el) {
        setTimeout(() => {
          this.$refs.current.SimpleBar.getScrollElement().scrollTop =
            this.$refs.current.SimpleBar.getScrollElement().scrollHeight + 1500;
        }, 50);
      }

        if (this.$refs.messagesbox.$el) {
            setTimeout(() => {
            this.$refs.messagesbox.SimpleBar.getScrollElement().scrollTop =
                this.$refs.messagesbox.SimpleBar.getScrollElement().scrollHeight + 1500;
            }, 50);
        }
    },

    changeStatus(){
        ChatApi.changeStatus(this.selectedUser==null? null : this.selectedUser.id)
    },

    markRead(){
        ChatApi.changeStatus(this.selectedUser==null? null : this.selectedUser.id).then(
            (result)=>{
                if(result && this.recentUsers.some(user => user.id === this.selectedUser.id)){
                    this.getRecentUsers()
                    this.handleScroll()
                }
            }
        )
        
    }

    },

    

};
</script>

<template>
<div>
    <div v-click-outside="config" class="right-bar">
        <simplebar class="h-100" ref="messagesbox" >

            <div class="d-lg-flex p-4">
            <div class="chat-leftsidebar mr-lg-4">
                <div class>
                <div class="py-4 border-bottom border-warning">
                    <div class="media">
                    <div class="align-self-center mr-3">
                        <img src="@/assets/images/users/avatar-1.png" class="avatar-xs rounded-circle" alt />
                    </div>
                    <div class="media-body">
                        <h5 class="font-size-15 mt-0 mb-1 text-primary">{{connectedUserFullName}}</h5>
                        <p class="text-muted mb-0">
                        <i class="mdi mdi-circle text-success align-middle mr-1 "></i> {{$t("chat.connected")}} 
                        </p>
                    </div>
                    </div>
                </div>
                </div>



                <div class="search-box chat-search-box py-4">
                        <b-input-group>
                          <b-form-input  :placeholder="$t('chat.placeholder')"  style="background-color:#f2f2f2" v-model="filter"  @keyup.native.enter="getChatUsers()" ></b-form-input>
                    
                          <template v-slot:append>
                              <b-button  size="sm" variant="warning" @click="getChatUsers()">
                              <i class="bx bx-search-alt font-weight-bold font-size-16 text-primary align-middle"></i>
                              </b-button>
                          </template>                            
                        </b-input-group>
                </div>

                <div class="chat-conversation" :class="!recentUsers.length ? 'd-none' : ''">
                    <!-- <ul class="list-unstyled">
                    <li>
                        <div class="chat-day-title">
                        <span class="title">{{$t("chat.recentContacts")}}</span>
                        </div>
                    </li>
                    </ul> -->
                    <h5 class="font-size-14 mb-3 mt-2 text-primary">{{$t("chat.recentContacts")}}</h5>
                </div>

                <div class="chat-leftsidebar-nav mb-4" :class="!recentUsers.length ? 'd-none' : ''">
                    <b-card-text>
                        <div>
                        <simplebar  style="max-height: 560px;">
                            <ul class="list-unstyled chat-list">
                            <li
                                v-for="data of recentUsers"
                                :key="data.id"
                                @click="chatRecentUsername(data)"
                                :class="{'active': selectedUser && selectedUser.id == data.id}"
                            >
                                <a href="javascript: void(0);">
                                <div class="media">
                                    <!-- <div class="align-self-center mr-3">
                                    <i :class="`mdi mdi-circle text-${data.color} font-size-10`"></i>
                                    </div> -->
                                    <div class="avatar-xs align-self-center mr-3" >
                                    <span
                                        class="avatar-title rounded-circle bg-soft-danger text-primary"
                                    >{{data.name.charAt(0).toUpperCase() + (data.name.charAt(1) ? data.name.charAt(1).toUpperCase() : '') }}</span>
                                    </div>
                                    <div class="row">
                                    <div class="col-11 media-body overflow-hidden">
                                        <h5 class="text-truncate text-dark font-size-14 mt-2">{{ data.name }}</h5> 
                                    </div>
                                    <div class="col-1">
                                         <!-- <b-badge pill  variant="danger" class="float-left">{{data.unreadMessagesCount}}</b-badge> -->
                                         <span class="badge badge-pill badge-danger  float-left ml-2 mt-2   ">{{data.unreadMessagesCount}}</span>
                                    </div>
                                    </div>
                                </div>
                                </a>
                            </li>
                            </ul>
                        </simplebar>
                        </div>
                    </b-card-text>

                </div>

                <div class="chat-leftsidebar-nav" >
                    <b-card-text>
                        <div>
                        <h5 class="font-size-14 mb-3 mt-2 text-primary">{{$t('chat.contactsList')}}</h5>
                        <simplebar  style="max-height: 560px;"  >
                            <ul class="list-unstyled chat-list" >
                            <li
                                v-for="data of usersList"
                                :key="data.id"
                                @click="chatUsername(data)"
                                :class="{'active': selectedUser && selectedUser.id == data.id}"
                            >
                                <a href="javascript: void(0);">
                                <div class="media">
                                    <!-- <div class="align-self-center mr-3">
                                    <i :class="`mdi mdi-circle text-${data.color} font-size-10`"></i>
                                    </div> -->
                                    <div class="avatar-xs align-self-center mr-3" >
                                    <span
                                        class="avatar-title rounded-circle bg-soft-info text-primary"
                                    >{{data.name.charAt(0).toUpperCase() + (data.name.charAt(1) ? data.name.charAt(1).toUpperCase() : '') }}</span>
                                    </div>
                                    <div class="media-body overflow-hidden">
                                    <h5 class="text-truncate text-dark font-size-14 mt-2">{{ data.name }}</h5>
                                    <p class="text-truncate mb-0">{{ data.message }}</p>
                                    </div>
                                    <div class="font-size-11">{{ data.time }}</div>
                                </div>
                                </a>
                            </li>
                            </ul>
                        </simplebar>
                        <span v-if="!isGettingChatContactStarting & !usersList.length" class="d-flex justify-content-center m-4 text-danger" >{{$t('chat.emptyList')}}</span>
                        <!-- <b-spinner  v-if="isGettingChatContactStarting" class="m-2" variant="primary" role="status"></b-spinner> -->
                            <div class="row">
                                <div class="col-12">
                                    <div class="text-center my-3">
                                    <a href="javascript:void(0);" class="text-warning" @click="loadMore()" v-if="pagemodelMain.totalRows> usersList.length ">
                                        <!-- <i class="bx bx-loader bx-spin font-size-18 align-middle mr-2"></i>  -->
                                        {{$t('chat.loadMore')}}
                                    </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-card-text>

                </div>
            </div>
            <div class="w-100 user-chat" v-if="selectedUser">
                <div class="card">
                    <div class="py-4 border-bottom border-warning">
                    <div class="media">
                    <div class="avatar-xs align-self-center mr-3" >
                        <span
                            class="avatar-title rounded-circle bg-soft-info text-primary"
                        >{{username.charAt(0).toUpperCase() + (username.charAt(1) ? username.charAt(1).toUpperCase() : '') }}</span>
                        </div>
                    <div class="media-body">
                        <h5 class="font-size-15 mt-0 mb-1 text-primary">{{username}}</h5>
                        <p class="text-muted mb-0">
                        <i class="text-success align-middle"></i>  {{$t("chat.intro")}} 
                        </p>
                    </div>
                    </div>
                </div>












<!-- 
                <div class="p-4 border-bottom border-warning">
                    <div class="row">
                    <div class="col-md-4 col-9">
                          <div class="media">
                        <div class="avatar-xs align-self-center mr-3" >
                        <span
                            class="avatar-title rounded-circle bg-soft-primary text-primary"
                        >{{username.charAt(0).toUpperCase() + (username.charAt(1) ? username.charAt(1).toUpperCase() : '') }}</span>
                        </div>
                        <h5 class="font-size-15 mb-1 text-primary">{{username}}</h5>
                         </div>
                        <p class="text-muted mb-0 invisible">
                        <i class="mdi mdi-circle text-success align-middle mr-1"></i> 
                        </p>
                    </div>

                    </div>
                </div> -->

                <div class="chat-users">
                    <div class="chat-conversation p-3" >
                    <simplebar id="chat-messages-list" ref="current" style="max-height: 580px;min-height:580px">
                        <ul class="list-unstyled">
                        <!-- <li>
                            <div class="chat-day-title">
                            <span class="title text-primary">Aujourd'hui</span>
                            </div>
                        </li> -->
                        <div class="row">
                            <div class="col-12">
                                <div class="text-center my-3">
                                <a href="javascript:void(0);" class="text-warning" @click="loadMoreMessages()" v-if="messagesPagemodelMain.totalRows> chatMessagesData.length ">
                                     {{$t('chat.previousMessages')}}... 
                                </a>
                                </div>
                            </div>
                        </div>
                        <li
                            v-for="data of chatMessagesData"
                            :key="data.id"
                            :class="{ 'right': (currentUserId!=data.toId) }"
                        >
                            <div class="conversation-list">
                            <div class="ctext-wrap">
                                <div class="conversation-name">{{ currentUserId==data.toId ? (selectedUser == null ? "" : selectedUser.name) : connectedUserFullName}}</div>
                                <p>{{ data.message }}</p>
                                <p class="chat-time mb-0">
                                <i class="bx bx-time-five align-middle mr-1"></i>
                                {{ data.timeStamp }}
                                </p>
                            </div>
                            </div>
                        </li>
                        </ul>                  
                    </simplebar>

                    </div>

                    <div class="p-3 chat-input-section">
                    <div class="row">
                        <div class="col">
                        <div class="position-relative">
                            <b-input
                            type="text"
                            class="form-control chat-input"
                            :placeholder="$t('chat.messagePlaceholder')"
                            style="background-color:#f2f2f2" 
                            v-model="message"
                            :maxlength="255"
                            rows="1"
                            max-rows="1"
                            @keyup.native.enter="send"
                            @click="markRead()" 
                            />
                            <div class="text-center">
                                <p
                                v-if="message"
                                class="badge position-absolute"
                                :class="{ 'badge-success': message.length !== 255,
                                            'badge-danger': message.length === 255 }"
                                >
                                {{ message.length }} /
                                255
                                </p>
                            </div>
                        </div>
                        </div>
                        <div class="col-auto ml-1">
                        <button type="submit" class="btn btn-warning btn-rounded chat-send w-md" @click.prevent="send" :disabled="!this.message" >
                            <span class="d-none d-sm-inline-block text-primary mr-2">{{$t('chat.send')}}</span>
                            <i class="mdi mdi-send text-primary"></i>
                        </button>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            </div>



        </simplebar>
    </div>

    <!-- Right bar overlay-->
    <div class="rightbar-overlay"></div>
</div>
</template>>

<style lang="scss"></style>


